import { render, staticRenderFns } from "./TestatorDocumentsCard.vue?vue&type=template&id=2655af48&scoped=true"
import script from "./TestatorDocumentsCard.vue?vue&type=script&lang=js"
export * from "./TestatorDocumentsCard.vue?vue&type=script&lang=js"
import style0 from "./TestatorDocumentsCard.vue?vue&type=style&index=0&id=2655af48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2655af48",
  null
  
)

export default component.exports